import { UnknownAction } from "redux-saga";
import { action } from "typesafe-actions";

import { InvalidatePayload, StoreModel } from "../models";

const invalidateActionType = "INVALIDATE";
// eslint-disable-next-line import/prefer-default-export
export const invalidate = (propertyName: keyof StoreModel): UnknownAction =>
  action(invalidateActionType, { propertyName } as InvalidatePayload);
